import React, { useState, useEffect } from 'react';
import AppStyles from "../../AppStyles";
import AppTheme from '../../AppTheme';
import {
    Text, View, Image, TextInput, StyleSheet,
    ScrollView, KeyboardAvoidingView, Pressable
} from 'react-native';
import { store } from "../../store/store";

import { pwaGUID } from '../CommonService';
import { getCurrentLocation } from '../../utils/services/locations/CurrentLocation';
import { familyDetailsSubscription, ScreenPushBackData, userDetailsSubscription } from "../../utils/services/subject-behaviour/CommonRxjsService";

import { PrimaryCTA } from '../../utils/widgets/CommonCTA';
import { CommonHeader } from "../../utils/widgets/CommonWidget/CommonHeader";
import { LocationIconView } from '../../utils/widgets/Location/Location-Widget';

import { LocationName } from '../../utils/constants/ConstantsMapping';
import { NavigateFrom, ScreenRoute } from '../../utils/constants/ScreenRouteConstant';

import TextStyle from '../../TextStyle';

import TitlePopup from '../../utils/modals/TitlePopup';
import CommonBottomSheet from '../../utils/modals/CommonBottomSheet';

import ModalContent from '../../utils/constants/ModalContentConstant';

import * as API from '../../utils/services/api/API';
import * as DateTime from "../../utils/services/DateTimeUtils";
import * as Redux from '../../utils/services/redux/commonRedux';
import * as CommonUtils from '../../utils/services/CommonUtils';
import * as AlertService from "../../utils/services/AlertLoaderService";

const CompleteProfile = (props) => {

    const reduxState = store.getState()
    const userDetails = reduxState.userDetails;
    const screenRedirect = props?.route?.params?.screenRedirect
    const [selectedLocation, updateSelectedLocation] = useState({});
    const [maleGenderSelected, setMaleGenderSelected] = useState(userDetails['maleGenderSelected'] ?? true);
    const [genderSelected, setGenderSelected] = useState(userDetails['genderSelected'] ?? false);
    const [name, setName] = useState(userDetails['name'] &&
        userDetails['name'] != 'N/a' ? userDetails['name'] : '');
    const [age, setAge] = useState(userDetails['inputAge'] ?? '');

    const [blockedLocationModal, setBlockedLocationModal] = useState(false)
    const [profileCreatedPopup, setProfileCreatedPopup] = useState(false);

    const isGeneralCompleteProfileFlow = props?.route?.params?.isGeneralFlow ?? false

    useEffect(() => {
        ScreenPushBackData.getPushBackData().subscribe((data) => {
            if (data['pushBackCode'] ==
                NavigateFrom.complete_proifle_for_search_location) {
                let fetchLocationData = data['pushBackData']
                updateSelectedLocation(fetchLocationData)
            }
            ScreenPushBackData.clearPushBackData()
        })
    }, [])

    function navigateToSearchLocality() {
        global.navigateFrom = NavigateFrom.complete_proifle_for_search_location
        props.navigation.navigate(ScreenRoute.search_locality)
    }

    const showBlockedLocationModal = () => {
        setBlockedLocationModal(true)
    }

    const closeBlockedLocationModal = () => {
        setBlockedLocationModal(false)
    }

    const onProfileCreation = () => {
        if (screenRedirect)
            props.navigation.replace(screenRedirect, {});
        else props.navigation.pop()
    }

    const showProfileCreatedPopup = () => {
        setProfileCreatedPopup(true)
    }

    const closeProfileCreatedPopup = () => {
        setProfileCreatedPopup(false)
    }

    function checkUserDataValidity() {
        return name && name != '' && name != 'N/a' &&
            userDetails && userDetails['id'] && userDetails['id'] != 0 &&
            selectedLocation && selectedLocation['address'] &&
            selectedLocation['address'] != '' &&
            age && age != '' &&
            parseInt(age) < 125 &&
            !(/\d/.test(name)) &&
            !(/[a-zA-Z]/.test(age) && genderSelected)
    }

    const saveMember = () => {
        var params = {
            name: name,
            relation: 'self',
            userId: userDetails['id'],
            appGUID: pwaGUID(),
            dob: DateTime.getTsFromAge(age),
            timezone: DateTime.getWebTimezone(),
            address: selectedLocation['address'],
            location: selectedLocation['location'],
            livingPlaceId: selectedLocation['pid'],
            gender: maleGenderSelected ? 'Male' : 'Female',
        };
        AlertService.loaderModal.setLoader(true);
        // disableScroll.on();
        API.doPost('accounts/update_user', params).then(
            (response: any) => {
                var userData = response;
                userData['isProfileComplete'] = true
                userData['isNameCaptured'] = true
                userData['familyId'] = userDetails['familyId']
                Redux.updateUserDetails(userData)
                Redux.updateFamilyData({ familyMembers: [userData] });
                userDetailsSubscription.setUserDetails(userData)
                familyDetailsSubscription.setFamilyDetails([userData])
                showProfileCreatedPopup()
                AlertService.loaderModal.setLoader(false);
            }, (err: any) => { console.log("API is failed with error " + err) }
        )
    }

    return (
        <KeyboardAvoidingView style={{ width: AppTheme.appWidth }}>

            <CommonHeader navigation={props.navigation} />

            <ScrollView style={{
                backgroundColor: AppTheme.color.background, minHeight: AppTheme.appHeight,
                marginTop: AppTheme.headerHeight, paddingHorizontal: 16, paddingVertical: 16
            }}>

                <Text style={TextStyle.text16xb}>
                    {isGeneralCompleteProfileFlow ? 'Hey there, please fill the details below' :
                        'Hey there, Doctor wants to know more about you'}</Text>

                <Text style={[TextStyle.text14, { marginTop: 18, marginBottom: 32 }]}>
                    {isGeneralCompleteProfileFlow ? 'This information will help us serve you better' :
                        'This information will help the doctor to consult you more effectively'}</Text>

                <View style={[AppStyles.mediumShadow, { backgroundColor: 'white', padding: 16, borderRadius: 12, marginBottom: 24 }]}>

                    <TextInput
                        style={[TextStyle.text14, styles.sectionStyle,
                        {
                            paddingVertical: 10,
                            paddingHorizontal: 16,
                            color: 'black'
                        }]}
                        placeholderTextColor={AppTheme.color.fillerInfo}
                        placeholder="Enter your name"
                        underlineColorAndroid="transparent"
                        maxLength={80}
                        value={name}
                        onChangeText={(text) => setName(text.replace(/[^a-z A-Z]/g, ''))} />

                    <TextInput
                        style={[TextStyle.text14, styles.sectionStyle, { marginTop: 16, paddingVertical: 10, paddingHorizontal: 16 }]}
                        placeholderTextColor={AppTheme.color.fillerInfo}
                        placeholder="Age"
                        underlineColorAndroid="transparent"
                        value={age}
                        keyboardType="numeric"
                        maxLength={3}
                        onChangeText={(text) => setAge(text.replace(/[^0-9]/g, ''))} />

                    <Text style={[TextStyle.text16xb, { marginTop: 32, marginBottom: 19 }]}>Select Gender</Text>

                    <View style={[AppStyles.flexRow]}>

                        <Pressable onPress={() => {
                            setMaleGenderSelected(true);
                            setGenderSelected(true)
                        }}
                            style={{
                                paddingHorizontal: 12, paddingVertical: 8,
                                borderRadius: 8, borderWidth: 2,
                                borderColor: AppTheme.color.primary,
                                backgroundColor: genderSelected && maleGenderSelected ?
                                    AppTheme.color.primary : 'white'
                            }}>
                            <Text style={[TextStyle.text14xb,
                            { color: genderSelected && maleGenderSelected ? 'white' : AppTheme.color.primary }]}>Male</Text>
                        </Pressable>

                        <Pressable onPress={() => { setMaleGenderSelected(false); setGenderSelected(true) }}
                            style={{
                                paddingHorizontal: 12, paddingVertical: 8, marginLeft: 16, borderRadius: 8, borderWidth: 2, borderColor: AppTheme.color.primary,
                                backgroundColor: genderSelected && !maleGenderSelected ? AppTheme.color.primary : 'white'
                            }}>
                            <Text style={[TextStyle.text14xb, { color: genderSelected && !maleGenderSelected ? 'white' : AppTheme.color.primary }]}>Female</Text>
                        </Pressable>

                    </View>

                    {
                        selectedLocation['isLocationFetched'] ?
                            <View style={{ marginTop: 24 }}>

                                <View style={[AppStyles.flexRow]}>
                                    {LocationIconView({
                                        locationName: LocationName.home,
                                        height: 18,
                                        width: 18
                                    })}
                                    <Text style={[TextStyle.text14xb, { marginLeft: 4 }]}>Home</Text>
                                </View>

                                <Text style={[TextStyle.text10b,
                                {
                                    color: AppTheme.color.grey.text,
                                    marginTop: 8
                                }]}>
                                    {selectedLocation['locationTitle']}</Text>

                            </View> :
                            <View style={{ marginTop: 24 }}>

                                <Pressable onPress={() => { navigateToSearchLocality() }}
                                    style={[AppStyles.flexRow, { paddingHorizontal: 16, paddingVertical: 10, borderRadius: 8, backgroundColor: AppTheme.color.background }]}>

                                    <Image source={{ uri: CommonUtils.getImagePath('/images/icons/search_grey.svg'), width: 24, height: 24 }} />

                                    <TextInput
                                        style={[TextStyle.text14, { paddingVertical: 10, paddingHorizontal: 16, marginLeft: 8, width: AppTheme.appWidth - 96 }]}
                                        placeholderTextColor={AppTheme.color.fillerInfo}
                                        placeholder="Search for street name / area"
                                        underlineColorAndroid="transparent"
                                        value={''}
                                        onChangeText={(text) => { }} />

                                </Pressable>

                                <Pressable style={[AppStyles.flexRow, { marginTop: 24 }]}
                                    onPress={() => {
                                        getCurrentLocation(true, showBlockedLocationModal).
                                        then((currentLocation: any) => {
                                            if (currentLocation) {
                                                updateSelectedLocation(currentLocation)
                                            }
                                        })
                                    }}>

                                    <Image source={{ uri: CommonUtils.getImagePath('/images/icons/gps.svg'), width: 18, height: 18 }} />

                                    <Text style={[TextStyle.text14xb, { marginLeft: 8, color: AppTheme.color.primary }]}>
                                        Use Current Location</Text>

                                </Pressable>

                            </View>
                    }

                </View>

                <PrimaryCTA text={'Add'} disabled={!checkUserDataValidity()}
                    action={() => { checkUserDataValidity() ? saveMember() : null }} />

            </ScrollView>

            <CommonBottomSheet key={'blocked location'}
                showModal={blockedLocationModal}
                modalData={ModalContent.BlockedLocation}
                closeModal={closeBlockedLocationModal}
                primaryAction={navigateToSearchLocality} />

            <TitlePopup showPopup={profileCreatedPopup}
                modalData={{
                    ...ModalContent.UserProfileCreated,
                    title: ModalContent.UserProfileCreated.title + name + '!'
                }} closeModal={closeProfileCreatedPopup}
                primaryAction={onProfileCreation} />

        </KeyboardAvoidingView>
    )
}

export default CompleteProfile;

const styles = StyleSheet.create(CommonUtils.addFontFamilylato({
    genderText: {
        textAlign: 'center', borderRadius: 4, fontSize: 14, fontWeight: 'bold'
    },
    input: {
        flex: 1, height: 35, fontSize: 16, padding: 10,
        color: AppTheme.color.fillerInfo
        // borderWidth: 1
    },
    container: {
        flex: 1,
        justifyContent: 'center',
        alignItems: 'center',
        margin: 10,
    },
    sectionStyle: {
        flexDirection: 'row',
        justifyContent: 'center',
        alignItems: 'center',
        backgroundColor: '#fff',
        borderWidth: 1, borderColor: 'black', borderRadius: 8,
        elevation: 0,
    },

    genderSection: {
        flex: 1,
        justifyContent: "flex-start",
        flexDirection: 'row',
        marginTop: 18
    },
    genderLabel: {
        color: AppTheme.color.primary
    },
    genderImages: {
        height: 50,
        width: 50,
        marginTop: 10,
    },
    imageBorder: {
        borderColor: AppTheme.color.primary,
        borderWidth: 4,
        borderRadius: 50
    },
    imageStyle: {
        paddingRight: 10,
        marginHorizontal: 10,
        height: 15,
        width: 15,
        resizeMode: 'stretch',
        alignItems: 'center',
        elevation: 0
    },
    logoLocation: {
        height: 15,
        width: 15,
        resizeMode: 'stretch',
        alignItems: 'center',
        elevation: 0,
        paddingRight: 10,
        marginHorizontal: 10,
    },
    genderElement: {
        width: 90,
        marginLeft: 10
    },
    relationSelection: {
        flex: 1,
        flexDirection: "row",
        flexWrap: "wrap",
        textAlign: "center",
        alignContent: "center",
        justifyContent: 'space-evenly',
        height: 50,
        marginVertical: 16
    },
    familyMembers: {
        borderRadius: 50,
        justifyContent: 'center',
        borderWidth: 2,
        padding: 2,
        paddingVertical: 5,
        borderColor: '#666666',
        margin: 5,
        width: 90,
        // height: 30,
    },
    selectedRelated: {
        backgroundColor: AppTheme.color.primary,
        color: '#fff'
    },
    relations: {
        fontSize: 12,
        paddingVertical: 10
    },
    textLocation: {
        flex: 1, borderColor: 'white', height: 35, fontSize: 14, fontWeight: '600', padding: 10
    },
    dateInput: {
        flex: 1, borderColor: 'white', height: 35,
        fontSize: 14, fontWeight: 600, padding: 10
    }

}))